import * as yup from 'yup';

export const DiffsFormSchema = yup.object({
  pid: yup.number().required(),
  category: yup.string().required(),
  gameType: yup.string().required(),
  from: yup.string().nullable(true),
  to: yup.string().nullable(true),
});

export type DiffsFormData = yup.InferType<typeof DiffsFormSchema>;
